import { render, staticRenderFns } from "./ResponseCommentModal.vue?vue&type=template&id=16d719d6&scoped=true&"
import script from "./ResponseCommentModal.vue?vue&type=script&lang=js&"
export * from "./ResponseCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./ResponseCommentModal.vue?vue&type=style&index=0&id=16d719d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d719d6",
  null
  
)

export default component.exports